import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { fetchProductList } from "../../utils/server"

// 创建异步 thunk
export const initHomeProducts = createAsyncThunk(
  'product/initHomeProducts',
  async () => {
    const baseParams = {
      pageNo: 1,
      pageSize: 4
    }
    const { code, data } = await fetchProductList(baseParams)
    if (code === 200 && data) {
      return data.list
    }
    return []
  }
)

const productSlice = createSlice({
  name: "product",
  initialState: {
    products: [],
    /** 首页产品展示 */
    homeProducts: [],
    homeProductsLoading: false,
    homeProductsError: null,
  },
  reducers: {
    setProducts(state, action) {
      state.products = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initHomeProducts.pending, (state) => {
        state.homeProductsLoading = true
        state.homeProductsError = null
      })
      .addCase(initHomeProducts.fulfilled, (state, action) => {
        state.homeProductsLoading = false
        state.homeProducts = action.payload
      })
      .addCase(initHomeProducts.rejected, (state, action) => {
        state.homeProductsLoading = false
        state.homeProductsError = action.error.message
      })
  },
})

export const { setProducts } = productSlice.actions
export default productSlice.reducer
